import {
  Apiv2GetRequest,
  Apiv2PutRequest,
  Apiv2PostMultipart,
} from '../../api-v2';
import { showNotif } from '../../modules/notification';

export const state = {
  data: {
    form: {},
    loading: false,
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeProfile(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getProfile({ commit }) {
    commit('changeProfile', {
      loading: true,
    });

    let result = await Apiv2GetRequest(`profile`);
    commit('changeProfile', {
      form: !result.error ? result.data.object : {},
    });

    return !result.error ? true : false;
  },

  async updateProfile({ commit, dispatch, state }) {
    commit('changeProfile', {
      loading: true,
    });

    const { data } = state;
    let result = await Apiv2PutRequest(`profile`, {
      ...data.form,
    });

    if (result) {
      commit('changeProfile', {
        loading: false,
      });

      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return !result.error ? true : false;
  },

  async uploadFotoKaryawan({ commit, state }, payload) {
    commit('changeProfile', {
      loading: true,
    });

    const { data } = state;
    const result = await Apiv2PostMultipart(`upload-image`, payload);
    commit('changeProfile', {
      loading: false,
    });

    if (!result.error) {
      commit('changeProfile', {
        form: {
          ...data.form,
          foto: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },
};
